var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import UsersTableRow from '@/modules/admin/components/UsersTableRow.vue';
import Tooltip from 'src/components/Tooltip.vue';
import { removeHashRevokeUserEmail } from '@/shared/utils/helpers';
import UserRevokeModal from '@/modules/admin/components/UserRevokeModal.vue';
import UserEnableModal from '@/modules/admin/components/UserEnableModal.vue';
import AccountManagementModalContainer from '@/modules/admin/containers/AccountManagementModal/AccountManagementModal.container.vue';
let UsersTable = class UsersTable extends Vue {
    constructor() {
        super(...arguments);
        this.showUserRevokeModal = false;
        this.showEnableUserModal = false;
        this.showAccountModal = false;
        this.selectedUser = null;
    }
    removeCsFromAccount(params) {
        return params;
    }
    confirmRevoke(user) {
        return user;
    }
    confirmActive(user) {
        return user;
    }
    showAccountInfo(user) {
        this.selectedUser = user;
        this.showAccountModal = true;
        return user;
    }
    disableUser(user) {
        this.selectedUser = user;
        this.showUserRevokeModal = true;
    }
    enableUser(user) {
        this.selectedUser = user;
        this.showEnableUserModal = true;
    }
    get removeHashRevokeUserEmail() {
        if (!this.selectedUser)
            return '';
        return removeHashRevokeUserEmail(this.selectedUser.email);
    }
};
__decorate([
    Prop({ default: () => [] })
], UsersTable.prototype, "users", void 0);
__decorate([
    Emit('removeCsFromAccount')
], UsersTable.prototype, "removeCsFromAccount", null);
__decorate([
    Emit('confirmRevoke')
], UsersTable.prototype, "confirmRevoke", null);
__decorate([
    Emit('confirmActive')
], UsersTable.prototype, "confirmActive", null);
__decorate([
    Emit('showAccountInfo')
], UsersTable.prototype, "showAccountInfo", null);
UsersTable = __decorate([
    Component({
        name: 'UsersTable',
        components: {
            UsersTableRow,
            Tooltip,
            UserRevokeModal,
            UserEnableModal,
            AccountManagementModalContainer,
        },
    })
], UsersTable);
export default UsersTable;
